import type { LastMonthExpenseInsightsDTO } from "../models/lastMonthExpenseInsightsDto";
import type { LastMonthExpenseInsightsEntity } from "../../domain/entities/LastMonthExpenseInsightsEntity";

export function lastMonthExpenseInsightsDtoToEntity(
  dto: LastMonthExpenseInsightsDTO,
): LastMonthExpenseInsightsEntity {
  return {
    insights: (dto.insights ?? []).map((item) => ({
      accentColor: (item.accentColor ?? "neutral") as
        | "success"
        | "warning"
        | "neutral",
      description: item.description ?? "",
    })),
    noInsights: dto.no_insights ?? false,
    monthLabel: dto.month_label ?? "",
    message: dto.message ?? null,
  };
}
